import { OpenAPI } from './api-generated';
import { logger } from './logger';

// Configure the generated API client
export const configureApiClient = () => {
  // Determine Base URL
  const getApiBaseUrl = () => {
    let url = import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || 'https://100billion.voni.dev';

    // Force HTTPS for non-localhost
    if (url && !url.includes('localhost') && !url.includes('127.0.0.1') && url.startsWith('http://')) {
      url = url.replace('http://', 'https://');
    }

    // Remove trailing slash if present (do this FIRST)
    if (url.endsWith('/')) {
      url = url.slice(0, -1);
    }

    // Remove /api/v1 if present, as the generated client adds it
    if (url.endsWith('/api/v1')) {
      url = url.slice(0, -7);
    }

    // Remove trailing slash again if /api/v1 was removed leaving a slash
    if (url.endsWith('/')) {
      url = url.slice(0, -1);
    }

    // Standardize localhost vs 127.0.0.1
    if (url.includes('127.0.0.1:8000')) {
      url = url.replace('127.0.0.1:8000', 'localhost:8000');
    }

    return url;
  };

  OpenAPI.BASE = getApiBaseUrl();

  // Ensure we send credentials (cookies)
  OpenAPI.WITH_CREDENTIALS = true;
  OpenAPI.CREDENTIALS = 'include';

  // Initialize token logic - usually overridden by AuthContext
  // But strictly avoid empty string which creates invalid "Bearer " header
  OpenAPI.TOKEN = undefined;

  // Add global headers (CSRF)
  OpenAPI.HEADERS = async () => {
    const headers: Record<string, string> = {};

    // Add CSRF token from cookie if present
    const getCookie = (name: string): string | null => {
      if (typeof document === 'undefined') return null;
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
      return null;
    };

    const csrfToken = getCookie('csrftoken');
    if (csrfToken) {
      headers['X-CSRF-Token'] = csrfToken;
    }

    return headers;
  };

  logger.info('Generated API Client configured with base:', { baseUrl: OpenAPI.BASE });
};
